export default __webpack_public_path__ + "static/media/ns.352bfcc7.svg";